import * as React from 'react';
import { cn } from '../../lib';

interface AppShellProps {
  children: React.ReactNode;
  sidebar: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  sidebarCollapsed?: boolean;
}

const AppShell = ({
  children,
  sidebar,
  header,
  footer,
  className,
  sidebarCollapsed = false,
}: AppShellProps) => {
  return (
    <div className={cn('flex h-screen bg-background', className)}>
      <aside
        className={cn(
          'hidden md:flex md:shrink-0 md:flex-col overflow-hidden border-r',
          'transition-[width] duration-sidebar ease-sidebar motion-reduce:transition-none',
          // Colapsado = padding del Sidebar (px-3) + padding del enlace (px-3) + ícono (1rem) a cada
          // lado: 0.75 + 0.75 + 1 + 0.75 + 0.75 = 4rem. Así el ícono queda centrado sin moverse.
          sidebarCollapsed ? 'md:w-16' : 'md:w-64',
        )}
      >
        {sidebar}
      </aside>
      <div className="flex flex-1 flex-col overflow-hidden">
        {header && (
          <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-40">
            {header}
          </header>
        )}
        <main className="flex-1 overflow-y-auto p-6">{children}</main>
        {footer && (
          <footer className="border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 p-4">
            {footer}
          </footer>
        )}
      </div>
    </div>
  );
};

interface SidebarProps {
  children: React.ReactNode;
  className?: string;
  collapsed?: boolean;
}

// El padding es idéntico colapsado y expandido: si cambiara, los íconos saltarían de posición.
const Sidebar = ({ children, className, collapsed }: SidebarProps) => (
  <nav
    data-collapsed={collapsed || undefined}
    className={cn('flex h-full w-full flex-col px-3 py-4', className)}
  >
    {children}
  </nav>
);

export { AppShell, Sidebar };
